import script from "./Profit.vue?vue&type=script&setup=true&lang=js"
export * from "./Profit.vue?vue&type=script&setup=true&lang=js"

import "./Profit.vue?vue&type=style&index=0&id=fb9655d0&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb9655d0"]])

export default __exports__